/* eslint-disable indent */
import React, { Component } from 'react';


class ForgotPassword extends Component {
    state = {
        resetPassEmail: '',
        is_btn_disbale: false,
        is_forgot: false,
        loader: false
    }

    UNSAFE_componentWillReceiveProps = (props) => {

        if (Object.keys(props.ForgotPwd.data).length > 0 && props.ForgotPwd.data !== this.props.ForgotPwd.data) {
            //
            this.setState({
                is_forgot: true,
                loader: false
            })
        }
        if (Object.keys(props.ForgotPwd.errors).length > 0 && props.ForgotPwd.errors !== this.props.ForgotPwd.errors) {
            // display error messsage
            this.setState({
                loader: false,
                is_forgot: false,
                LoginErrors: props.ForgotPwd.errors.email && props.ForgotPwd.errors.email,
            })
        }
    }


    // set value
    userOnChange = (e) => {
        const REGULAR_EXPRESSION_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        this.setState({ [e.target.name]: e.target.value })

        if (e.target.value.toString().toLowerCase().match(REGULAR_EXPRESSION_EMAIL)) {
            this.setState({
                is_btn_disbale: true
            })
        }
        else {
            this.setState({
                is_btn_disbale: false
            })
        }
    }

    // forgot password api
    forgotPassword = (e) => {
        e.preventDefault();
        let { resetPassEmail } = this.state;
        this.setState({
            loader: true
        })
        this.props.forgotPassword({ 'email': resetPassEmail, is_crm: false })
    }

    render() {
        let { resetPassEmail, LoginErrors, is_btn_disbale, is_forgot, loader } = this.state;
        return (
            <React.Fragment>
                {
                    is_forgot ?
                        <React.Fragment >
                            <div className="text-one">Thank you!</div>
                            <div className="text-two">Your password reset information has been sent to your email.</div>
                            <div className="link back-to-sign-in" onClick={() => { this.props.toggleView() }}>Back to Sign In</div>
                        </React.Fragment > : < React.Fragment >
                            <div className="text-one">Forgot Password?</div>
                            <div className="text-two">Sit. Stay. We&apos;ll email you instructions to reset your password.</div>
                            <div className="err_msg">{LoginErrors}</div>
                            <form onSubmit={(e) => { this.forgotPassword(e) }}>
                                <input
                                    type='resetPassEmail'
                                    aria-label='email'
                                    className='form--control'
                                    placeholder='Email Address'
                                    name='resetPassEmail'
                                    id='resetPassEmail'
                                    value={resetPassEmail}
                                    onChange={(e) => { this.userOnChange(e) }}
                                />
                                <div className="link" onClick={() => { this.props.toggleView() }}>Back to Sign In</div>
                                <div className='submit_btn'>
                                    <button
                                        aria-label='reset-button'
                                        type='submit'
                                        disabled={!is_btn_disbale}
                                        // onClick={() => this.forgotPassword()}
                                        className='btn btn btn--secondary'
                                    >
                                        Recover Password
                                     </button>
                                </div>
                            </form>
                        </React.Fragment >
                }
                {
                    loader ?
                        <div className='loader_wrapper'>
                            <div className='loader07'></div>
                        </div>
                        : ''
                }
            </React.Fragment>
        );
    }
}

export default ForgotPassword;